<!-- Copyright: Seán I. O'Donoghue -->

<template>
  <li v-if="to" :class="{selected: selected}">
    <router-link :to="to">
      <slot />
    </router-link>
  </li>
  <li v-else :class="{selected: selected}">
    <a>
      <!-- for items with no link; needs '<a></a>' for consistent styling -->
      <slot />
    </a>
  </li>
</template>

<script setup>
const log = (msg) => process.env.VUE_APP_DEV && console.log(); // eslint-disable-line
// eslint-disable-next-line
const props = defineProps({
  to: {default: ""},
  selected: {default: false}
});
</script>

<style scoped>
li {
  list-style-type: none;
  text-align: right;
  padding: 0;
  margin: 0;
  letter-spacing: 0.03em;
  vertical-align: text-bottom; /* needed? improves vertical alignment */
  text-shadow: none;
  box-shadow: none;
  border: none;
  box-sizing: border-box;
}
a {
  display: inline-flex; /* needed for arrow; inline-flex = problems  */
  display: flex; /* enables background-color to span menu */
  justify-content: flex-end; /* needed for right align */
  align-content: top;
  margin: 0;
  padding: 0.3rem 1rem;
  box-sizing: border-box;
}
a:hover {
  text-decoration: none;
}
/* color while selected */
/* li.selected a {
  color: var(--primary-navigation-color) !important;
  background-color: var(--brand-hover-color) !important; 
}
li.selected a:hover {
  background-color: var(--brand-color) !important; 
} */
</style>
